import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import { extraOptionPropTypes } from './PropTypes';

import UpgradeCard from '../BookingFieldset/UpgradeCard';

const propTypes = exact({
  options: PropTypes.arrayOf(extraOptionPropTypes).isRequired,
  perPersonText: PropTypes.string,
});

const defaultProps = {
  perPersonText: 'pp',
};

// previously MiscExtraGroup
function Extras(props) {
  return (
    <div className="UpgradeGroup">
      <div className="UpgradeGroup_itemGroup">
        {props.options.map((extraOption) => (
          <div className="UpgradeGroup_item UpgradeGroup_item-fullWidth" key={extraOption.key}>
            <UpgradeCard
              blockName="UpgradeGroup_card"
              description={extraOption.fullDescription}
              images={[extraOption.image]}
              isSelected
              title={extraOption.title || 'extraOption.title missing'}
              perPersonText={props.perPersonText}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

Extras.propTypes = propTypes;
Extras.defaultProps = defaultProps;

export default Extras;
